// Shared Google Maps Platform config. Reuses the SAME key the rest of the app
// already uses for Places/Geocoding — no new env var names to configure.

export function getGooglePlacesApiKey() {
  return (
    process.env.REACT_APP_GOOGLE_PLACES_API_KEY ||
    process.env.REACT_PUBLIC_GOOGLE_PLACES_API_KEY ||
    process.env.REACT_APP_GOOGLE_CIVIC_API_KEY ||
    ''
  );
}

// Advanced Markers require a valid Map ID created in Google Cloud Console →
// Map Management. Reads from REACT_APP_GOOGLE_MAP_ID; falls back to Google's
// built-in 'DEMO_MAP_ID' only when the env var is absent (local dev without .env).
export const GOOGLE_MAP_ID =
  process.env.REACT_APP_GOOGLE_MAP_ID || 'DEMO_MAP_ID';

// Libraries needed across the app's map usage. 'marker' enables AdvancedMarkerElement.
export const GOOGLE_MAPS_LIBRARIES = ['places', 'marker'];

// Center of the contiguous US — fallback when no events have coordinates.
export const US_CENTER = { lat: 39.8283, lng: -98.5795 };
export const US_DEFAULT_ZOOM = 4;
